import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ClockIcon } from '../../../../assets/images/Clock.svg';
import { BrizTvApp as IBrizTvApp } from '../../../../models/Common';

const App: FC<IBrizTvApp> = ({ title, description, link, hoverText, ...props }) => {
  const { t } = useTranslation();
  return (
    <div className={link ? 'briz-tv-app briz-tv-app__link' : 'briz-tv-app briz-tv-app__hover'}>
      <div className="briz-tv-app__icon">
        <props.icon />
      </div>
      <div className="briz-tv-app__text">
        <p className="briz-tv-app__text__title">{t(`success.brizTv.${title}`)}</p>
        <div className="briz-tv-app__text__name">
          <props.name />
        </div>
        <p className="briz-tv-app__text__description">{t(`success.brizTv.${description}`)}</p>
      </div>
      {hoverText && <p className="briz-tv-app__hover__text">{t(hoverText)}</p>}
      {!link && !hoverText && (
        <>
          <ClockIcon className="briz-tv-app__developing__icon" />
          <p className="briz-tv-app__hover__text">{t('success.brizTv.applicationUnderDevelopment')}</p>
        </>
      )}
    </div>
  );
};

export const BrizTvApp: FC<IBrizTvApp> = (props) => {
  const { link } = props;
  if (link) {
    return (
      <a href={link} target="_blank" rel="noreferrer">
        <App {...props} />
      </a>
    );
  }
  return <App {...props} />;
};
